import { Link } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { useIsUserLoggedIn, useLogin } from 'components/user/UserProvider';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import SubmitForm from '../SubmitForm/SubmitForm';
import styles from './SubmitLanding.module.css';

const LessonSubmitForm: React.FC = () => {
  const isUserLoggedIn = useIsUserLoggedIn();
  const login = useLogin();

  return (
    <Paper className={styles.content}>
      <Typography variant="h5" component="h2" className={styles.header}>
        Submit Your Lesson
      </Typography>
      {isUserLoggedIn ? (
        <SubmitForm />
      ) : (
        <Typography>
          Help grow our resource library! To submit a lesson, you must sign up for an account.
          Please signup{' '}
          <Link component={RouterLink} to="/signup">
            here
          </Link>
          , or if you already have an account,{' '}
          <Link component="button" onClick={login}>
            <Typography>login</Typography>
          </Link>
          .
        </Typography>
      )}
    </Paper>
  );
};

export default LessonSubmitForm;
